<template>
    <div class="history-management-view" :class="{'padding-present': !showItemsChanges}">
        <div class="subsidiary-container h-full">
            <div class="subsidiary-content max-content-height" :class="{'filter-active': filterStatus}">
                <div class="sub-header relative flex gap-10">
                    <h4 class="subsidiary-title">{{kycReviewInfo.name}}</h4>
                    
                    <img src="@/assets/filter.svg" v-if="!filterActive && !showItemsChanges" class="pointer" @click="showFilter()">
                    <img src="@/assets/filter-active.svg" v-else-if="filterActive && !showItemsChanges" class="pointer" @click="showFilter()">

                    <div v-if="filterStatus" class="cover-elem"></div>
                    <div class="filter-area" v-if="filterStatus">
                        <div class="cross" @click="filterStatus = false">
                            <img src="@/assets/cross.svg" alt="cross"/>
                        </div>
                        <h4 class="subsidiary-title">Filters:</h4>
                        <div class="filters-list flex gap-20 row wrap">
                            <div class="review-data flex gap-5px">
                                <InpComponent
                                    class="input-el country-select flex-1 w-200"
                                    label="Review Date Present"
                                    type="options"
                                    :options="[{value: '', text: 'All'}, {value: 'yes', text: 'Yes'}, {value: 'no', text: 'No'}]"
                                    :key_ref="'review_date_present'"
                                    :value="filters.review_date_present"
                                    @inputChange="filterInputChange"
                                />
                                <InpComponent
                                    v-if="filters.review_date_present != 'no'"
                                    class="input-el country-select  w-content"
                                    label="Review Date After"
                                    type="date"
                                    placeholder=""
                                    :key_ref="'review_start_date'"
                                    :value="filters.review_start_date"
                                    @inputChange="filterInputChange"
                                />
                                <InpComponent
                                    v-if="filters.review_date_present != 'no'"
                                    class="input-el country-select flex-1 w-content"
                                    type="date"
                                    label="Review Date Before"

                                    placeholder="Client Type"
                                    :key_ref="'review_end_date'"
                                    :value="filters.review_end_date"
                                    @inputChange="filterInputChange"
                                />
                            </div>
                            <div class="review-data flex gap-5px">
                                <InpComponent
                                    v-if="filters.added_at != 'no'"
                                    class="input-el country-select  w-content"
                                    label="Created Date After"
                                    type="date"
                                    placeholder=""
                                    :key_ref="'added_at_start'"
                                    :value="filters.added_at_start"
                                    @inputChange="filterInputChange"
                                />
                                <InpComponent
                                    v-if="filters.added_at != 'no'"
                                    class="input-el country-select flex-1 w-content"
                                    type="date"
                                    label="Created Date Before"
                                    placeholder="Client Type"
                                    :key_ref="'added_at_end'"
                                    :value="filters.added_at_end"
                                    @inputChange="filterInputChange"
                                />
                            </div>
                        </div> 
                        <div class=" w-full mt-20 flex row gap-10">
                            <div class="stick-right"></div>
                            <button class="w-content" v-if="filterActive" @click="clearFilter()">Clear</button>
                            <button class="w-content" @click="applyFilter()">Apply</button>
                        </div>
                    </div>
                    <InpComponent
                            class="search-input"
                            icon="search"
                            type="text"
                            :value="searchVal"
                            placeholder="Search"
                            key_ref="search"
                            @inputChange="inputChangeFunc"
                        />
                    <div class="info flex gap-5 align-center">
                        <button v-if="!showItemsChanges" class="button" @click="addCompany()">
                            Add New 
                            <!-- {{ kycReviewInfo.button }}  -->
                            Client
                        </button>
                    </div>
                </div>
                <div v-if="!loadingPage && dataList && dataList.length" class="w-full full-minus-pagination overflow-y-auto">
                    <table class="subsidiary-list w-full">
                        <thead style="position: sticky; top: 0; z-index: 10; background: #F6F6FC;">
                            <tr>
                                <th class='ordering' :class="['name', 'first_name'].includes(sortingKey) ? 'sort-on' : ''" @click="sort(kycReviewInfo.type == 'corporate' ? 'name' : 'first_name' )">{{ kycReviewInfo.list_title }}
                                    <svg class='sort' :class="`orientation-${sorting[kycReviewInfo.type == 'corporate' ? 'name' : 'first_name']}`" xmlns="http://www.w3.org/2000/svg" width="320" height="512" viewBox="0 0 320 512"><path fill="currentColor" d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19 287.9 32 287.9h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                                </th>
                                <th class='ordering' :class="sortingKey == 'location_type' ? 'sort-on' : ''" @click="sort('location_type')" >Location Type
                                    <svg class='sort' :class="`orientation-${sorting['location_type']}`" xmlns="http://www.w3.org/2000/svg" width="320" height="512" viewBox="0 0 320 512"><path fill="currentColor" d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19 287.9 32 287.9h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                                </th>
                                <th v-if="showItemsChanges" class='ordering' :class="sortingKey == 'company_type' ? 'sort-on' : ''" @click="sort('company_type')" >Client Type
                                    <svg class='sort' :class="`orientation-${sorting['company_type']}`" xmlns="http://www.w3.org/2000/svg" width="320" height="512" viewBox="0 0 320 512"><path fill="currentColor" d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19 287.9 32 287.9h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                                </th>

                                <th class='ordering' :class="sortingKey == 'createdAt' ? 'sort-on' : ''" @click="sort('createdAt')">Created At
                                    <svg class='sort' :class="`orientation-${sorting['createdAt']}`" xmlns="http://www.w3.org/2000/svg" width="320" height="512" viewBox="0 0 320 512"><path fill="currentColor" d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19 287.9 32 287.9h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                                </th>
                                
                                <th v-if="showItemsChanges">
                                    {{ getViewName(view) }}
                                </th>
                            </tr>
                        </thead>
                        <tbody class='table-content' v-if="dataList">
                            <tr class="account-list" 
                                v-for="company in dataList" 
                                :key="company._id" 
                                @click="openItem(company)">
                                
                                <td class="user-info"> 
                                    {{ company.name || company.first_name }} {{ company.last_name }}
                                </td>
                                <td class="user-info"> 
                                    {{  getCompanyType(company) }}
                                </td>
                            
                                <td v-if="showItemsChanges"> 
                                    {{ getClientType(company.company_type) }}
                                </td>

                                <td class="user-info"> 
                                    {{  Utils.renderTime(company.createdAt) }}
                                </td>
                            
                                <td v-if="showItemsChanges" class="user-info"> 
                                    {{  company.changesCount }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <LoaderPopup v-else-if="loadingPage" class='w-full' :message="`Loading Data...`"/> -->
                <div class='w-full p-20 border-box no-data-present' v-else>
                    No {{  kycReviewInfo.name_plural }} yet
                </div>
            </div>
            <vue-awesome-paginate
                v-if="!loadingPage && dataList && dataList.length && itemsCount > 30"
                class="pagination"
                :total-items="itemsCount"
                :items-per-page="30"
                :max-pages-shown="8"
                v-model="currentPage"
                @click="handlePageClick"
            />
            <PopupCover v-if="showAddPopup" @close="() => showAddPopup = false">
                <PopupBody @close="() => showAddPopup = false" v-if="!addingNewLoading"> 
                    <template #header>Add new Client</template>
                    <template #body>

                        
                     
                        <div class="add-new-subsidiary-area" v-if="newCompany.company_type == 'corporate'">
                            <InpComponent 
                                :value="newCompany.name" 
                                :key_ref="'name'"
                                @inputChange="inputChangeFunc"
                                :label="`${kycReviewInfo.name} Name`"
                                :error="nameError"
                            />
                            <InpComponent
                                class="country-select flex-1"
                                label="Company Type"
                                type="options"
                                :options="[{value: 'local', text: 'Onshore'}, {value: 'abroad', text: 'Offshore'}]"
                                placeholder="Company Type"
                                :key_ref="'location_type'"
                                :error="locationTypeError"
                                :value="newCompany.location_type"
                                @inputChange="inputChangeFunc"
                            />
                            <button class="save-button" @click="saveCompany()">Save</button>
                        </div>
                        <div class="add-new-subsidiary-area" v-else-if="newCompany.company_type == 'account_holder'">
                            <InpComponent 
                                :value="newCompany.first_name" 
                                :key_ref="'first_name'"
                                @inputChange="inputChangeFunc"
                                :label="`${kycReviewInfo.button}\`s First Name`"
                                :error="nameError"
                            />
                            <InpComponent 
                                :value="newCompany.last_name" 
                                :key_ref="'last_name'"
                                @inputChange="inputChangeFunc"
                                :label="`${kycReviewInfo.button}\`s Last Name`"
                                :error="lastnameError"
                            />
                            <InpComponent
                                class="country-select flex-1"
                                label="Type"
                                type="options"
                                :options="[{value: 'bank', text: 'Bank'}, 
                                    {value: 'credit_union', text: 'Credit Union'},
                                    {value: 'pention', text: 'Pension'},
                                    {value: 'insurance', text: 'Insurance'},
                                    {value: 'player', text: 'Player'}
                                ]"
                                placeholder="Type"
                                :key_ref="'account_holder_type'"
                                :error="locationTypeError"
                                :value="newCompany.account_holder_type"
                                @inputChange="inputChangeFunc"
                            />

                            <button class="save-button" @click="saveCompany()">Save</button>
                        </div>
                    </template>
                </PopupBody>
                <LoaderPopup v-else :message="`Adding New ${ kycReviewInfo.name }...`"/>
            </PopupCover>
        </div>
    </div>
</template>


<script setup>
        
    import { ref, defineEmits, computed, withDefaults, defineProps, watch, onMounted } from 'vue'
    import PopupCover from '@/components/PopupCover.vue';
    import PopupBody from '@/components/PopupBody.vue';
    import InpComponent from '@/components/InpComponent.vue';
    import LoaderPopup from '@/components/LoaderPopup.vue';
    import API from '../api/index.js'
    import { useRouter, useRoute } from 'vue-router'
    import { useStore } from 'vuex';
    import Utils from '@/utils/index.js';
    // import 'vue-awesome-paginate/dist/style.css'


    const dateRange = ref({
        startDate: new Date(),
        endDate: new Date(),
    });
    function updateValues(){
        console.log('updateValues', dateRange.value);
    }
    const store = useStore();
    const router = useRouter();
    const showAddPopup = ref(false);
    const dataList = ref([]);
    const addingNewLoading = ref(false);
    const nameError = ref(null);
    const lastnameError = ref(null);
    const locationTypeError = ref(null);
    const clientTypeError = ref(null);
    const loadingPage = ref(true);
    const searchVal = ref('');
    const sorting = ref({createdAt: -1});
    const sortingKey = ref('createdAt');
    const debounce = ref(null);
    const validationIsOn = ref(false);
    const kycReviewInfo =ref({});
    const props = defineProps(['kyc_type', 'showItemsChanges', 'view']);
    const currentPage = ref(1);
    const itemsCount = ref(1);
    const filterStatus = ref(false);



    const showFilter = () => {
        filterStatus.value = !filterStatus.value;
    }
    const handlePageClick = (page) => {
        currentPage.value = page;
        doRequest();
    }

    const filters = ref({
        
    })
    function clearFilter() {
        filters.value = {};
        filterStatus.value = false;
        doRequest();
    }
    const filterActive = computed(() => {
        return Object.keys(filters.value).length > 0;
    })
    function filterInputChange(event){
        filters.value[event[0]] = event[1];
        if (!event[1]) {
            delete filters.value[event[0]];
        }
    }
    async function applyFilter(){
        await doRequest();
        filterStatus.value = false;
    }
    const lastSearch = ref('');
    const newCompany = ref({
        name: '',
        company_type: props.kyc_type,
        location_type: '',
        account_holder_type: '',
        first_name: '',
        last_name: '',
    });

    const sortingState = ref({
        name: 1,
        first_name: 1,
        createdAt: 1,
        company_type: 1,
        location_type: 1,
    })
    async function sort(key) {
        sortingKey.value = key;
        sortingState.value[key] = sortingState.value[key] * -1;
        sorting.value = { [key]: sortingState.value[key] };
        await doRequest()

    }
    function getClientType(company_type){
        if (company_type == 'corporate'){
            return 'Company';
        } else {
            return 'Account Holder';
        }
    }
    function getCompanyType(company){
        if (company.company_type == 'corporate'){
            return company.location_type == 'local' ? 'Onshore' : 'Offshore';
        } else {
            return 'Onshore';
        }
    }
    function getViewName(view){
        if (view == 'forConfirmation'){
            return 'Workflow Elements';
        } else {
            return 'Change Log Elements';
        }
    }

    async function doRequest(){
        loadingPage.value = true;
        let response = null;
        if (props.showItemsChanges) {
            response = await API.getNotificationsByCompany({
                view: props.view,
                search: searchVal.value,
                ordering: sorting.value,
                page: currentPage.value,
            });
            dataList.value = response.data;
            itemsCount.value = response.count;
        } else {

            let finalFilters = {
                ...filters.value,
            }
            if (props.kyc_type == 'corporate') {
                finalFilters.company_type = 'corporate';
            } else {
                finalFilters.company_type = 'account_holder';
            }

            response = await API.getCompamniesList(
                searchVal.value, 
                sorting.value, 
                currentPage.value,
                finalFilters
            );
            dataList.value = response.companies;
            itemsCount.value = response.count;
        }
        loadingPage.value = false;
        lastSearch.value = searchVal.value;
    }

    function handleSearch(search){
        searchVal.value = search;

        if (searchVal.value.length < 3){
            if (lastSearch.value && searchVal.value.length == 0){
                doRequest()
            }
            return 
        }
        if (debounce.value){
            clearTimeout(debounce.value);
        }
        debounce.value = setTimeout(async () => {
            await doRequest();
        }, 500);
    }

    function inputChangeFunc(event){
        if (event[0] == 'search'){
            handleSearch(event[1]);
        }
        
        newCompany.value[event[0]] = event[1];
        if (validationIsOn.value){
            validateFields();
        }
    }
    function validateFields(){
        nameError.value = null;
        validationIsOn.value = true;
        locationTypeError.value = null;
        lastnameError.value = null;
        let errorPresent = false;
        if (!newCompany.value.company_type) {
            clientTypeError.value = 'Client Type is required';
            errorPresent = true;
        }
        if (props.kyc_type == 'corporate') {
            if (!newCompany.value.name) {
                nameError.value = 'Name is required';
                errorPresent = true;
            }
            if (!newCompany.value.location_type) {
                locationTypeError.value = 'Company type is required';
                errorPresent = true;
            }
        } else {
            if (!newCompany.value.first_name) {
                nameError.value = 'First Name is required';
                errorPresent = true;
            }
            if (!newCompany.value.last_name) {
                lastnameError.value = 'Last Name is required';
                errorPresent = true;
            }
            if (!newCompany.value.account_holder_type) {
                locationTypeError.value = 'Client Type type is required';
                errorPresent = true;
            }
        }
        return errorPresent;
    }
    function openItem(item) {
        store.dispatch('setValue', { key: 'companyData', value: null});
        if (props.showItemsChanges) {

            let types = {
                'forConfirmation': 'workflow-item',
                'forHistory': 'change-log-item',
            }
            let router_el = {name: types[props.view], params: {id: item._id}} 
            router.push(router_el);
            return;
        }
        router.push({name: 'client-item', params: {id: item._id}});
    }

    async function saveCompany() {
        if (validateFields()) {
            return;
        }
        addingNewLoading.value = true;
        const response = await API.createCompany(newCompany.value);
        if (response.status === 'success') {
            showAddPopup.value = false;
        } else {
            locationTypeError.value = 'Something went wrong';
            return;
        }
        addingNewLoading.value = false;
        router.push({name: 'client-item', params: {id: response.company._id}});
    }

    function addCompany() {
        showAddPopup.value = true;  
    }

    async function initiate() {
    
        kycReviewInfo.value = {
            title: 'Clients KYC',
            name: 'Client',
            name_plural: 'Clients',
            list_title: 'Client List',
        }
        if (props.kyc_type == 'corporate') {
            kycReviewInfo.value.type = 'corporate';
            kycReviewInfo.value.name = 'Corporate Clients';
            kycReviewInfo.value.name_plural = 'Companies';
            kycReviewInfo.value.list_title = 'Company Name';
            kycReviewInfo.value.item = ''
            kycReviewInfo.value.button = 'Corporate';
        }
        if (props.kyc_type == 'account_holder') {
            kycReviewInfo.value.type = 'account_holder';
            kycReviewInfo.value.name = 'Non Corporate Clients';
            kycReviewInfo.value.name_plural = 'Account Holders';
            kycReviewInfo.value.list_title = 'Account Holders List';
            kycReviewInfo.value.item = ''
            kycReviewInfo.value.button = 'Account Holder';
        }
        if (props.showItemsChanges) {
            kycReviewInfo.value = {
                title: 'Clients KYC',
                name: 'Client',
                name_plural: 'Clients',
                list_title: 'Clients List',
            };
        } else {
            document.title = `${kycReviewInfo.value.name} - KYC`;
        }
        await doRequest();
    }

    onMounted(async () => {
        if (!store.state.user) {
            router.push({name: 'login'});
            return;
        }
        await initiate();

    })

    // watch props_kyc_type
    watch(async () => props.kyc_type, (newVal, oldVal) => {
        if (oldVal) {
           initiate();
        }
    })
    watch(async () => props.view, (newVal, oldVal) => {
        if (oldVal) {
           initiate();
        }
    })


</script>



<style lang="scss" scoped>
   .pagination[class] {
        margin: 20px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;

        &:deep(button) {
            padding: 10px 20px;
        }
        &:deep(.active-page) {
            // background-color: var(--button-hover-color-blue);
            background: #00408985;
            color: white;
        }
    }
   .documentmanagement-header {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 20px;
        text-align: left;
        color: black;
        padding-top: 20px;
    }
    .padding-present {
        padding: 20px;
    }
    .history-management-view {
        display: flex;
        flex-direction: column;
        max-width: 1350px;
        box-sizing: border-box;
        // margin: auto;
    }
    .subsidiary-container {
        width: 100%;
    }
    .subsidiary-content {
        min-width: 100%;
        border: 1px solid #ccc;
        border-radius: 10px;
        width: fit-content;
    }
    .sort {
        width: 13px;
        height: 16px;
        margin-left: 5px;
        margin-top: -2px;
        opacity: 0.8;
        &.orientation-1 {
            transform: rotateX(180deg);
            margin-bottom: -7px;
        }
    }
    .ordering {
        cursor: pointer;
        color: black;
        // font-size: 16px;
        font-weight: 600;
        &.sort-on {
            .sort {
                color: var(--primary-color);

            }
        }
    }
    
    .sub-header {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        padding: 20px;
        padding-left: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: white;
    }
    
    .subsidiary-title {
        display: flex;
        justify-content: space-between;
        color: black;
        font-size: 20px;
    }
    
    .sub-header {
        display: flex;
        justify-content: space-between;
        button {
            width: fit-content;
            padding: 10px;
        }
    }
    .search-input {
        width: 300px;
        margin-bottom: 0;
        margin-right: auto;
    }
    .subsidiary-list {
        padding: 20px;
        width: 100%;
        border-collapse: collapse;
        th, td {
            // border: 1px solid #ccc;
            padding: 15px;
            text-align: left;
            border: none;
            padding-left: 30px;
            color: black;
        }
        td {
            padding-top: 19px;
            padding-bottom: 19px;
        }
        th {
            text-align: left;
            border: none;
        }
        tr {
            border-top: 1px solid #ccc;
        }
        tbody {
            tr {
                cursor: pointer;
                td {
                    background: white;
                }

                &:last-child {
                    td {
                        &:first-child {
                            border-bottom-left-radius: 10px;
                        }
                        &:last-child {
                            border-bottom-right-radius: 10px;
                        }
                    }
                }
                &:hover {
                    td {
                        background: #f9f9f9;
                    }
                }
            }
        }
    }
    
    .add-new td{
        padding-top: 0px;
        padding-bottom: 0px;
    
    }
    .save-button {
        padding: 10px 20px;
        width: fit-content;
        margin-left: auto;
    }
    h4 {
        margin: 0;
    }
    .add-new-subsidiary-area {
        justify-content: center;
        align-items: center;
    
    }
    .text-input {
        &:deep(input) {
            text-align: center;
        }
    }
    .more-actions {
    padding: 5px 0px;
    border-radius: 4px;
    width: 35px;
    height: 25px;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
        background: #d9d9d9;

        .dropdown {
            display: flex;
            flex-direction: column;

        }
    }
    position: relative;

    .dropdown {
        display: none;
        position: absolute;
        top: 35px;
        right: 0;
        background: white;
        border: 1px solid #ccc;
        border-radius: 4px;
        z-index: 100;
        div {
            padding: 10px;
            cursor: pointer;
            &:hover {
                background: #d9d9d9;
            }
        }
    }
}

.filter-area {
    padding: 15px 30px;
    box-sizing: border-box;
    position: absolute;
    top: 60px;
    left: 1px;
    right: 1px;
    min-height: 180px;
    height: fit-content;
    background-color: white;
    z-index: 10000;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border: 1px solid #ccc;
}

.info-line {
    color: black;
    text-align: left;
    font-weight: 600;
    margin: 0;
}
.line-label {
    text-align: left;
    font-weight: 600;
    margin: 0;
    margin-top: 5px;
    font-size: 12px;
    color: rgb(151, 151, 151);
}
.filters-list {
    padding-top: 20px;

    .input-el {
        margin-bottom: 0;
    }
}
.stick-right {
    margin-left: auto;
}
.cover-elem {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    width: 100%;
    height: 100%;
}
.cross {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
}
.full-minus-pagination {
    height: calc(100% - 65px);
}
.max-content-height {
    max-height: calc(100vh - 165px);
    overflow-y: auto;
    &.filter-active {
        min-height: 240px;
        overflow-y: visible;
        
    }
}
</style>